export default {
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: "/welcome/quiz_turkey_coding_new122022_dekstop.png",
    imageMobile: "/welcome/quiz_turkey_coding_new122022_mobile.png",
    title: "Çocuğunuz için ücretsiz oyun yapma dersi ayırtmak için 5 soruyu yanıtlayın",
    subtitle: "Deneme dersinde çocuk, karakterler ile yerleri geliştirecek ve kendi oyununu yaratacaktır",
    button: "Ücretsiz almak için tıklayın",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz için ne eğlenceli olacak:",
      answers: [
        "🎨 3D oyun yerleri geliştirin",
        "🧑‍🎤 Karakter oluşturun",
        "🏕 Oyun grafikleri oluşturun",
        "📱 Oyun programlama",
        "❓ Bilmiyorum",
      ],
    },
    2: {
      question: "Çocuğunuz kendi oyununu yaratabilecek mi?",
      answers: [
        "👾 Evet, zaten bunu daha önce yapmıştı",
        "🤩 Bilmiyorum ama öğrenmek isterim",
      ],
    },
    3: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: [
        {
          answer: "💻 Evet",
          distribution_tag_question: [18],
        },
        {
          answer: "😐 Hayır",
          stopAnswer: true
        },
      ],
    },
    4: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    5: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz. Lütfen çocuğunuzun doldurduğu yaşı seçin.",
      button: "İleri 🚀",
    },
    6: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
      button: "İleri 🚀",
    },
    7: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    8: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    9: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "Son adım! 🎉",
    },
  },
};
